var map = {
	"./0.png": "8cf1",
	"./1.png": "d1dd",
	"./2.png": "0f62",
	"./3.png": "d780",
	"./4.png": "0880",
	"./5.png": "22e5",
	"./6.png": "1edf",
	"./7.png": "63e9",
	"./8.png": "55e7",
	"./9.png": "7646",
	"./base.png": "c033",
	"./default/0.png": "e74c",
	"./default/1.png": "8b79",
	"./default/2.png": "5fc7",
	"./default/3.png": "92c2",
	"./default/4.png": "3df2",
	"./default/5.png": "af06",
	"./default/6.png": "4270",
	"./default/7.png": "6b05",
	"./default/8.png": "bdfa",
	"./default/9.png": "96c0",
	"./default/base.png": "5620",
	"./xmyz/0.png": "f9f9",
	"./xmyz/1.png": "4a4c",
	"./xmyz/2.png": "2360",
	"./xmyz/3.png": "0134",
	"./xmyz/4.png": "d9fe",
	"./xmyz/5.png": "c3b3",
	"./xmyz/6.png": "524e",
	"./xmyz/7.png": "88a8",
	"./xmyz/8.png": "71de",
	"./xmyz/9.png": "c867",
	"./xmyz/base.png": "7af2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a86";